/* eslint-disable no-undef */
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { orangeIcon } from '../components/map/orange_icon';
import { blueIcon } from '../components/map/blue_icon';

import { getContent, getHeader } from '../common/content';
import { debounceLoadMarker } from '../common/tools';

export const Context = React.createContext();

//Medellin
// const center = {
//   lat: 6.230833,
//   lng: -75.590553,
// };

//Bogotá
const center = {
  lat: 4.6592648,
  lng: -74.162618,
};

export const ContextProvider = ({ children }) => {
  const [map, setMap] = useState();
  const [infoWindow, setInfoWindow] = useState();
  const [activeMarkerId, setActivemarkerid] = useState();
  const [bounds, setBounds] = useState(0);
  const [dropPointsComplete, setDroppointsComplete] = useState([]);
  const [dropPoints, setDroppoints] = useState([]);
  const [mapMarkers, setMapmarkers] = useState([]);
  const [lastZoom, setLastZoom] = useState(14);
  const [filter, setFilter] = useState(0);

  const setLastCenter = (newCenter) => {
    window.lastCenter = newCenter;
  };

  const handleCloseMarker = () => {
    setActivemarkerid(null);
    map.setCenter(window.lastCenter);
    map.setZoom(lastZoom);
    infoWindow.setContent('');
    infoWindow.setHeaderContent('');
    infoWindow.setAnchor(null);
  };

  const loadMarker = (point) => {
    const icon = blueIcon();

    const marker = new window.google.maps.marker.AdvancedMarkerElement({
      map,
      position: { lat: point.lat, lng: point.lng },
      content: icon.element,
      title: point.label,
      // collisionBehavior: window.google.maps.CollisionBehavior.OPTIONAL_AND_HIDES_LOWER_PRIORITY
    });

    marker.id = point.id;
    marker.cname = point.label;

    marker.addListener('click', async () => {
      const icon = orangeIcon();
      map.panTo(marker.position);
      map.setZoom(17);
      marker.content = icon.element;

      infoWindow.setHeaderContent(getHeader(point));
      infoWindow.setContent(getContent(point));
      infoWindow.open({
        anchor: marker,
        map: map,
        shouldFocus: false,
      });
      setActivemarkerid(point.id);
      window.google.maps.event.clearInstanceListeners(infoWindow);
      infoWindow.addListener('closeclick', () => {
        infoWindow.set('anchor', null);
        infoWindow.close();
        handleCloseMarker();
      });
    });

    return marker;
  };

  const setVisibleMarkers = (markers, value) => {
    if (value) {
      markers
        .filter((x) => map?.getBounds()?.contains(x.position))
        .forEach((x) => {
          if (!x.map) {
            x.map = map;
          }
        });
    } else {
      markers.forEach((x) => (x.map = null));
    }
  };

  const loadMarkers = () => {
    if (mapMarkers.length <= 0) {
      const localMarkers = [];
      for (const point of dropPointsComplete) {
        localMarkers.push(loadMarker(point));
      }

      setMapmarkers(localMarkers);
    } else {
      setVisibleMarkers(mapMarkers, false);
    }

    if (filter === 0) {
      setDroppoints(dropPointsComplete ?? []);
      setVisibleMarkers(mapMarkers, true);
      return;
    }

    if (filter === 10) {
      const filteredPoints =
        dropPointsComplete?.filter((x) => !x.label?.includes('Aliado')) ?? [];
      const filteredMarkers =
        mapMarkers?.filter((x) => !x.cname?.includes('Aliado')) ?? [];
      setVisibleMarkers(filteredMarkers, true);
      setDroppoints(filteredPoints);
      return;
    }
    if (filter === 20) {
      const filteredPoints =
        dropPointsComplete?.filter((x) => x.label?.includes('Aliado')) ?? [];
      const filteredMarkers =
        mapMarkers?.filter((x) => x.cname?.includes('Aliado')) ?? [];
      setVisibleMarkers(filteredMarkers, true);
      setDroppoints(filteredPoints);
      return;
    }
  };

  const debouncedLoadmarkers = useCallback(
    debounceLoadMarker(loadMarkers, 1000),
    [loadMarkers]
  );

  useEffect(() => {
    setLastCenter(center);
    setLastZoom(14);
  }, []);

  useEffect(() => {
    if (map && dropPointsComplete.length > 0) {
      debouncedLoadmarkers();
    }
  }, [map, dropPointsComplete]);

  useEffect(() => {
    if (map && !infoWindow) {
      setInfoWindow(
        new window.google.maps.InfoWindow({
          content: '',
          oncloseclick: handleCloseMarker,
        })
      );
    }
  }, [map]);

  useEffect(() => {
    if (infoWindow?.getContent() == '') {
      infoWindow.close();
    }
  }, [dropPoints]);
  useEffect(() => {
    debouncedLoadmarkers();
  }, [bounds]);

  return (
    <Context.Provider
      value={{
        map,
        setMap,
        activeMarkerId,
        setActivemarkerid,
        bounds,
        setBounds,
        dropPoints,
        setDroppoints,
        mapMarkers,
        setMapmarkers,
        center,
        setLastCenter,
        lastZoom,
        setLastZoom,
        loadMarkers,
        dropPointsComplete,
        setDroppointsComplete,
        filter,
        setFilter,
      }}
    >
      {children}
    </Context.Provider>
  );
};

ContextProvider.propTypes = {
  children: PropTypes.element,
};
